import React from 'react';
import PropTypes from 'prop-types';
import { getTypeInfo } from 'credit-card-type';

import { normalizePaymentType } from 'helpers/MyAccountUtils';
import MartyLink from 'components/common/MartyLink';

const makeBillingAddress = (billingAddress, testId) => {
  if (billingAddress) {
    const { fullName, addressLine1, addressLine2, city, stateOrRegion, postalCode, countryName } = billingAddress;
    return (
      <div>
        <div data-test-id={testId('priPaymentName')}>{fullName}</div>
        <div data-test-id={testId('priPaymentAddress1')}>{addressLine1}</div>
        <div data-test-id={testId('priPaymentAddress2')}>{addressLine2}</div>
        <div data-test-id={testId('priPaymentCityStateZip')}>{city}, {stateOrRegion} {postalCode}</div>
        <div data-test-id={testId('priPaymentCountry')}>{countryName}</div>
      </div>
    );
  } else {
    return null;
  }
};

const PrimaryPayment = ({ payment }, { testId }) => {
  if (payment) {
    const { paymentType, addCreditCardNumber, expirationMonth, expirationYear, billingAddress } = payment;
    const cardType = getTypeInfo(normalizePaymentType(paymentType))?.niceType;

    return (
      <div data-test-id={testId('primaryPayment')}>
        <h3>Primary Payment Information</h3>
        <div>{cardType} ending in {addCreditCardNumber}</div>
        <div>Exp. {expirationMonth}-{expirationYear}</div>
        {makeBillingAddress(billingAddress, testId)}
        <MartyLink to="/payments" data-test-id={testId('managePayments')}>Manage My Payment Info</MartyLink>
      </div>
    );
  } else {
    return (
      <div data-test-id={testId('primaryPaymentEmpty')}>
        <h3>Primary Payment Information</h3>
        <div>No card set as primary</div>
        <MartyLink to="/payments/new" data-test-id={testId('addNewPaymentPlus')}>Add a new card</MartyLink>
      </div>
    );
  }
};

PrimaryPayment.contextTypes = {
  testId: PropTypes.func
};

PrimaryPayment.propTypes = {
  payment: PropTypes.object
};

export default PrimaryPayment;
